import { type Comune } from '@framework/api-client/api/inquiries/schemas/comune.ts';
import { type Provincia } from '@framework/api-client/api/inquiries/schemas/provincia.ts';
import { type IProvinceListOptions } from './mapProvinceList.ts';

export class ProvinceWidgetLogic {
  static getDefaultValue(params: {
    defaultValue: { province?: string | null; town?: string | null };
    current: { province?: string | null; town?: string | null };
    options: IProvinceListOptions;
  }) {
    const { defaultValue, current, options } = params;

    let currentProvince = options.provinces.find(
      p => p.value === current.province,
    )?.context;
    let originalProvince = true;

    if (!currentProvince) {
      currentProvince = options.provinces.find(
        p => p.value === defaultValue.province,
      )?.context;
      originalProvince = false;
    }

    let currentTown = options.towns.find(
      t => t.value === current.town,
    )?.context;
    let originalTown = true;

    if (!currentTown) {
      currentTown = options.towns.find(
        t => t.value === defaultValue.town,
      )?.context;
      originalTown = false;
    }

    // 1. Se sono entrambi definiti e allineati, ritorno i dati
    if (
      currentProvince &&
      currentTown &&
      ProvinceWidgetLogic.isTownInProvince(currentTown, currentProvince)
    ) {
      return {
        province: currentProvince,
        town: currentTown,
      };
    }

    // 2. Se sono entrambi definiti ma non allineati, ritorno i dati della provincia
    if (
      currentProvince &&
      currentTown &&
      !ProvinceWidgetLogic.isTownInProvince(currentTown, currentProvince)
    ) {
      return {
        province: currentProvince,
        town: undefined,
      };
    }

    // 3. Se manca il comune, ritorno solo la provincia
    if (!currentTown && currentProvince) {
      return {
        province: currentProvince,
        town: undefined,
      };
    }

    // 4. Se manca la provincia, ritorno il comune e imposto la provincia
    if (currentTown && !currentProvince) {
      const townProvince = options.provinces.find(
        p => p.value === currentTown?.provincia,
      )?.context;
      if (townProvince) {
        return {
          province: townProvince,
          town: currentTown,
        };
      }
      return {
        province: undefined,
        town: undefined,
      };
    }

    // 5. Se manca tutto, ritorno i dati di default
    return {
      province: undefined,
      town: undefined,
    };
  }

  static isTownInProvince(
    town: Comune | null | undefined,
    province: Provincia | null | undefined,
  ) {
    if (!town || !province) return false;
    return town.provincia === province.codiceBelfiore;
  }
}
